import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "17",
  height: "22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 13.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 10 6.125v-1.5A3.375 3.375 0 0 0 6.625 1.25H4.75m0 12.75h7.5m-7.5 3H8.5M7 1.25H2.125C1.504 1.25 1 1.754 1 2.375v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V10.25a9 9 0 0 0-9-9Z",
  stroke: "#02504B",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }